import { Phone, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-1">
        <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList>
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="inline-flex items-center justify-center rounded-md px-4 py-2 text-sm font-medium text-foreground hover:bg-secondary hover:text-foreground transition-all duration-150">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Header() {
  return <header className="bg-background border-b border-border shadow-soft">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {}
          <div className="flex-shrink-0 animate-fade-in-up">
            <Link to="/" className="inline-block focus-ring rounded-md">
              <img src="https://alignphysiotherapy.co.uk/wp-content/uploads/2026/01/Align-Logo-1.png" alt="Align Physiotherapy" className="h-7" />
            </Link>
          </div>

          {}
          <nav className="hidden md:flex items-center animate-fade-in-up-delay-100">
            <MenuProvider menu_id="17">
              <HeaderMenuConsumer />
            </MenuProvider>
          </nav>

          {}
          <div className="hidden lg:flex items-center gap-6 text-sm text-muted-foreground animate-fade-in-up-delay-200">
            <Link to="tel:+447463682889" className="flex items-center gap-2 hover:text-primary transition-all duration-150 focus-ring rounded-md px-2 py-1">
              <Phone className="size-4" />
              <span className="font-medium">07463682889</span>
            </Link>
            <Link to="mailto:appointments@alignphysiotherapy.co.uk" className="flex items-center gap-2 hover:text-primary transition-all duration-150 focus-ring rounded-md px-2 py-1">
              <Mail className="size-4" />
              <span className="font-medium">appointments@alignphysiotherapy.co.uk</span>
            </Link>
          </div>
        </div>
      </div>
    </header>;
}